import $ from 'cash-dom';
import { matchHover } from '../media';

/**
 * This module open/closes the mobile menu and submenus
 */
export default class HeaderModule {

    static name = 'header';

    constructor(node) {

        const $header = $(node);

        $header.find('.header-toggle').on('click', () => {
            $header.toggleClass('open');

            if($header.hasClass('open')) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                $('body').addClass('overflow-hidden');
            } else {
                $('body').removeClass('overflow-hidden');
            }
        });

        $header.find('.header-subnav-toggle').on('click', function() {
            const $li = $(this).closest('.header-navitem');
            $li.toggleClass('open');
        });

        if(matchHover.matches) {
            $header.find('.header-subnav-toggle').each(function() {
                const $li = $(this).closest('.header-navitem');
                $li.on('mouseenter', () => $li.addClass('open'));
                $li.on('mouseleave', () => $li.removeClass('open'));
            });
        }
    }
}